import { useState } from "react";
import { ProSidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import { tokens } from "../../theme";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
import DomainDisabledIcon from "@mui/icons-material/DomainDisabled";
import PersonPinIcon from "@mui/icons-material/PersonPin";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import EmojiTransportationIcon from "@mui/icons-material/EmojiTransportation";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import MessageIcon from "@mui/icons-material/Message";
import { useCookies } from "react-cookie";
import { jwtDecode } from "jwt-decode";

const Item = ({ title, to, icon, selected, setSelected }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <MenuItem
      active={selected === title}
      style={{
        color: colors.white[500],
      }}
      onClick={() => setSelected(title)}
      icon={icon}
    >
      <Typography style={{ fontSize: 16 }}>{title}</Typography>
      <Link to={to} />
    </MenuItem>
  );
};

const Sidebar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [selected, setSelected] = useState("Dashboard");
  const [cookie] = useCookies(["token"]);
  const decoded = jwtDecode(cookie["token"]);
  const jsonData = JSON.parse(decoded.userInfo);
  return (
    <Box
      style={{ display: "flex", flexDirection: "column", position: "relative" }}
      sx={{
        "& .pro-sidebar": {
          position: "sticky",
        },
        "& .pro-sidebar-inner": {
          color: "#000 !important",
          background: `${colors.zamzamBrandGreen[500]} !important`,
          zIndex: "100%",
        },
        "& .pro-arrow": {
          color: "#fff !important",
          backgroundColor: "transparent !important",
        },
        "& .pro-icon-wrapper": {
          color: "#fff !important",
          backgroundColor: "transparent !important",
        },
        "& .pro-arrow-wrapper": {
          color: "#000 !important",
          backgroundColor: "transparent !important",
        },
        "& .suffix-wrapper": {
          color: "#fff",
          // backgroundColor: "transparent !important",
        },
        "& .pro-inner-item": {
          color: "#fff !important",
          padding: "5px 30px 5px 5px !important",
        },
        "& .pro-inner-item:hover": {
          backgroundColor: "#1A8D90",
          // marginRight:"10px",002572
          // marginLeft:"20px",
          // borderRadius:"5px",
          color: "#fff !important",
        },
        "& .pro-menu-item.active": {
          backgroundColor: "#1A8D90",
          // backgroundColor:"#E6E6E6",
          // marginRight:"10px",
          // marginLeft:"20px",
          borderRadius: "5px",
          // color: "#002572 !important",
          color: "#fff !important",
        },
      }}
    >
      <ProSidebar collapsed={isCollapsed}>
        <Menu iconShape="square">
          {/* LOGO AND MENU ICON */}
          <MenuItem
            onClick={() => setIsCollapsed(!isCollapsed)}
            icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
            style={{
              margin: "10px 0 20px 0",
              color: colors.zamzamBrandGrey[500],
            }}
          >
            {!isCollapsed && (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                ml="10px"
              >
                <img
                  alt="ZamZam Bank"
                  width="200px"
                  height="50px"
                  src={`../../assets/ZamZamlogowight.webp`}
                  style={{ cursor: "pointer", backgroundColor: "transparent" }}
                />
                <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
                  <MenuOutlinedIcon />
                </IconButton>
              </Box>
            )}
          </MenuItem>

          {/* {!isCollapsed && (
            <Box mb="25px">
              
              <Box textAlign="center">
                <Typography
                  variant="h4"
                  color={colors.grey[100]}
                  fontWeight="bold"
                  sx={{ m: "10px 0 0 0" }}
                >
                  Kelbesa Merga
                </Typography>
                <Typography variant="h6" color={colors.greenAccent[500]}>
                  Software Developer
                </Typography>
              </Box>
            </Box>
          )} */}

          <Box paddingLeft={isCollapsed ? undefined : "3%"}>
            <Item
              title="Dashboard"
              to="/"
              icon={<HomeOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />

            {jsonData.roles.name === "Super Admin" && (
              <SubMenu
                style={{
                  fontSize: 16,
                  color: colors.white[500],
                }}
                suffix={<span color="#fff"></span>}
                title={"Manage User"}
                icon={<ManageAccountsIcon />}
              >
                <Item
                  title="Users"
                  to="/users"
                  icon={<PeopleOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                />
                <Item
                  title="Roles"
                  to="/roles"
                  icon={<AccessAlarmIcon />}
                  selected={selected}
                  setSelected={setSelected}
                />
              </SubMenu>
            )}
            {jsonData.roles.name !== "Company User" && (
              <SubMenu
                style={{
                  fontSize: 16,
                  color: colors.white[500],
                }}
                suffix={<span color="#fff"></span>}
                title={"Manage Company"}
                icon={<EmojiTransportationIcon />}
              >
                {jsonData.roles.name !== "Company Admin" && (
                <Item
                  title="Companys"
                  to="/companies"
                  icon={<DomainDisabledIcon />}
                  selected={selected}
                  setSelected={setSelected}
                />
                )}
                 <Item
                  title="Company Users"
                  to="/company"
                  icon={<PersonPinIcon />}
                  selected={selected}
                  setSelected={setSelected}
                />
                <Item
                  title="Accounts"
                  to="/accounts"
                  icon={<AccountBalanceWalletIcon />}
                  selected={selected}
                  setSelected={setSelected}
                />
                {jsonData.roles.name !== "Company Admin" && (
                <Item
                  title="Messages"
                  to="/message"
                  icon={<MessageIcon />}
                  selected={selected}
                  setSelected={setSelected}
                />
                )}
              </SubMenu>
            )}

            {(jsonData.roles.name === "Company User" || jsonData.roles.name === "Company Admin") && (
              <SubMenu
                style={{
                  fontSize: 16,
                  color: colors.white[500],
                }}
                suffix={<span color="#fff"></span>}
                title={"Your Statements"}
                icon={<AccountBalanceIcon />}
              >
                <Item
                  title="Statements"
                  to="/statement"
                  icon={<ReceiptLongIcon />}
                  selected={selected}
                  setSelected={setSelected}
                />
              </SubMenu>
            )}
          </Box>
        </Menu>
        <Typography
          style={{
            marginLeft: "150px",
            color: "#fff",
            marginTop: "auto",
            alignSelf: "center",
          }}
        >
          V 0.1
        </Typography>
      </ProSidebar>
    </Box>
  );
};

export default Sidebar;
